module.exports = __webpack_public_path__ + "static/belong-678616ea0931820271e83b6ef469d701.jpg";